import { render, staticRenderFns } from "./asignarIntegrante.vue?vue&type=template&id=44d05022"
import script from "./asignarIntegrante.vue?vue&type=script&lang=js"
export * from "./asignarIntegrante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports